import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit {
 
 @Input() items: any;
 @Input() selectedItem!: string;
 @Input() labelField?: string;
 @Input() class?: string;

 @Output() onEmit: EventEmitter<string> = new EventEmitter();
 
 ngOnInit(): void {
}
 
 constructor() { 
 }


 onChangeSelectedItem(value: string) {
   this.onEmit.emit(value);
 }

 
}
